import React from "react";

/**
 * iPhone mockup frame. Pass `image` prop (URL) to display inside the screen.
 */
export default function PhoneMockup({ image, className = "" }) {
  return (
    <div className={`relative mx-auto w-[290px] h-[600px] md:w-[320px] md:h-[660px] ${className}`}>
      {/* Outer frame */}
      <div className="absolute inset-0 rounded-[48px] bg-navy-950 shadow-[0_40px_80px_-20px_rgba(0,0,0,0.45),0_0_0_2px_rgba(255,255,255,0.06)_inset] p-2">
        {/* Inner screen */}
        <div className="w-full h-full rounded-[40px] overflow-hidden relative bg-black">
          {/* Dynamic island */}
          <div className="absolute top-3 left-1/2 -translate-x-1/2 w-24 h-7 rounded-full bg-black z-20 shadow-[0_0_0_1px_rgba(255,255,255,0.05)_inset]" />
          {image ? (
            <img
              src={image}
              alt="Application B.health"
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover object-top"
              data-testid="phone-mockup-img"
            />
          ) : (
            <div className="absolute inset-0 bg-gradient-to-b from-navy-800 to-navy-950" />
          )}
        </div>
      </div>
      {/* Side buttons */}
      <div className="absolute left-[-3px] top-[18%] w-[3px] h-10 rounded-l-md bg-navy-900" />
      <div className="absolute left-[-3px] top-[28%] w-[3px] h-16 rounded-l-md bg-navy-900" />
      <div className="absolute left-[-3px] top-[42%] w-[3px] h-16 rounded-l-md bg-navy-900" />
      <div className="absolute right-[-3px] top-[24%] w-[3px] h-24 rounded-r-md bg-navy-900" />
    </div>
  );
}
